// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.citizen-checklist {
  list-style: none;
  margin: 0;
  padding: 0;
}

.citizen-checklist--indented {
  padding-left: 22px;
  border-left: 2px solid #EE5B43;
  margin: 20px 0 32px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.citizen-checklist--indented li {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-left: 4px;
  font-size: 13px;
  color: #000000;
}

.citizen-checklist--indented li strong {
  font-weight: 400;
}

.citizen-check-icon {
  color: #EE5B43;
  font-size: 15px;
  flex-shrink: 0;
}

.citizen-body-label {
  color: #1a1a1a;
}

.citizen-cta-group {
  display: inline-flex;
  flex-direction: column;
  gap: 18px;
  margin-top: 32px;
}

.citizen-cta-item {
  display: block;
  width: 100%;
}

.citizen-cta-item .btn {
  width: 100%;
  text-align: center;
}

.citizen-video-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-decoration: none;
  background: #FFFFFF;
  border: 1px solid #EE5B43;
  border-radius: 8px;
  padding: 16px 20px;
  transition: border-color 0.25s ease, transform 0.25s ease, box-shadow 0.25s ease;
}

.citizen-video-card:hover {
  border-color: #EE5B43;
  transform: translateY(-2px);
}

.citizen-video-logo {
  height: 26px;
  width: auto;
  object-fit: contain;
  margin-bottom: 10px;
}

.citizen-video-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: #EE5B43;
  margin-bottom: 6px;
}

.citizen-video-title {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #EE5B43;
  line-height: 1.4;
}

@media (max-width: 600px) {
  .citizen-cta-group {
    margin-top: 24px;
  }

  .citizen-video-card {
    padding: 14px 16px;
  }

  .citizen-video-title {
    font-size: 12px;
  }

  .citizen-video-logo {
    height: 22px;
  }
}

/* ───────── Responsive : tablette, contenu centré ───────── */
@media (max-width: 768px) {
  .citizen-text {
    text-align: center;
  }

  .citizen-checklist--indented {
    border-left: none;
    padding-left: 0;
    align-items: flex-start;
    margin-left: auto;
    margin-right: auto;
    width: fit-content;
  }

  .citizen-checklist--indented li {
    justify-content: flex-start;
  }

  .citizen-cta-group {
    align-items: center;
    margin-left: auto;
    margin-right: auto;
  }

  .citizen-video-card {
    align-items: center;
    text-align: center;
  }
}

/* ───────── Responsive : mobile, contenu centré ───────── */
@media (max-width: 480px) {
  .citizen-text {
    text-align: center;
  }

  .citizen-checklist--indented {
    border-left: none;
    padding-left: 0;
    align-items: flex-start;
    margin-left: auto;
    margin-right: auto;
    width: fit-content;
  }

  .citizen-checklist--indented li {
    justify-content: flex-start;
  }

  .citizen-cta-group {
    align-items: center;
    margin-left: auto;
    margin-right: auto;
  }

  .citizen-video-card {
    align-items: center;
    text-align: center;
  }
}

@media (max-width: 360px) {
  .citizen-checklist--indented li {
    font-size: 12px;
  }

  .citizen-video-title {
    font-size: 11.5px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/CitizenSection/CitizenSection.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gFAAgF;AAClF;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,8DAA8D;AAC9D;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA,4DAA4D;AAC5D;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".citizen-checklist {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.citizen-checklist--indented {\n  padding-left: 22px;\n  border-left: 2px solid #EE5B43;\n  margin: 20px 0 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.citizen-checklist--indented li {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding-left: 4px;\n  font-size: 13px;\n  color: #000000;\n}\n\n.citizen-checklist--indented li strong {\n  font-weight: 400;\n}\n\n.citizen-check-icon {\n  color: #EE5B43;\n  font-size: 15px;\n  flex-shrink: 0;\n}\n\n.citizen-body-label {\n  color: #1a1a1a;\n}\n\n.citizen-cta-group {\n  display: inline-flex;\n  flex-direction: column;\n  gap: 18px;\n  margin-top: 32px;\n}\n\n.citizen-cta-item {\n  display: block;\n  width: 100%;\n}\n\n.citizen-cta-item .btn {\n  width: 100%;\n  text-align: center;\n}\n\n.citizen-video-card {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  text-decoration: none;\n  background: #FFFFFF;\n  border: 1px solid #EE5B43;\n  border-radius: 8px;\n  padding: 16px 20px;\n  transition: border-color 0.25s ease, transform 0.25s ease, box-shadow 0.25s ease;\n}\n\n.citizen-video-card:hover {\n  border-color: #EE5B43;\n  transform: translateY(-2px);\n}\n\n.citizen-video-logo {\n  height: 26px;\n  width: auto;\n  object-fit: contain;\n  margin-bottom: 10px;\n}\n\n.citizen-video-label {\n  display: block;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n  color: #EE5B43;\n  margin-bottom: 6px;\n}\n\n.citizen-video-title {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #EE5B43;\n  line-height: 1.4;\n}\n\n@media (max-width: 600px) {\n  .citizen-cta-group {\n    margin-top: 24px;\n  }\n\n  .citizen-video-card {\n    padding: 14px 16px;\n  }\n\n  .citizen-video-title {\n    font-size: 12px;\n  }\n\n  .citizen-video-logo {\n    height: 22px;\n  }\n}\n\n/* ───────── Responsive : tablette, contenu centré ───────── */\n@media (max-width: 768px) {\n  .citizen-text {\n    text-align: center;\n  }\n\n  .citizen-checklist--indented {\n    border-left: none;\n    padding-left: 0;\n    align-items: flex-start;\n    margin-left: auto;\n    margin-right: auto;\n    width: fit-content;\n  }\n\n  .citizen-checklist--indented li {\n    justify-content: flex-start;\n  }\n\n  .citizen-cta-group {\n    align-items: center;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .citizen-video-card {\n    align-items: center;\n    text-align: center;\n  }\n}\n\n/* ───────── Responsive : mobile, contenu centré ───────── */\n@media (max-width: 480px) {\n  .citizen-text {\n    text-align: center;\n  }\n\n  .citizen-checklist--indented {\n    border-left: none;\n    padding-left: 0;\n    align-items: flex-start;\n    margin-left: auto;\n    margin-right: auto;\n    width: fit-content;\n  }\n\n  .citizen-checklist--indented li {\n    justify-content: flex-start;\n  }\n\n  .citizen-cta-group {\n    align-items: center;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .citizen-video-card {\n    align-items: center;\n    text-align: center;\n  }\n}\n\n@media (max-width: 360px) {\n  .citizen-checklist--indented li {\n    font-size: 12px;\n  }\n\n  .citizen-video-title {\n    font-size: 11.5px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
